import React from 'react';
import { Typography } from '@fiverr-private/typography';
import { Container, Stack } from '@fiverr-private/layout_components';
import { translate } from '../../shared/helpers';
import { GigCategory } from '../../shared/types';
import DragScrollCarousel from '../DragScrollCarousel';
import { menuContainerClass, menuItemClass, menuItemTextClass, carouselGapClass } from './styles.ve.css';

interface GigCategoriesMenuProps {
  categories: GigCategory[];
  onCategorySelect: (index: number) => void;
  selectedIndex: number;
}

const GigCategoriesMenu: React.FC<GigCategoriesMenuProps> = ({ categories, onCategorySelect, selectedIndex }) => (
  <Container
    maxWidth="100%"
    width="100%"
    marginBottom={{
      default: '6',
      sm: '7',
      md: '8',
    }}
    className={menuContainerClass}
  >
    <DragScrollCarousel
      gap="3"
      showFadeOverlay={true}
      className={carouselGapClass}
      disableWheel={true}
      disableScroll={true}
    >
      {categories.map((category, index) => {
        const isSelected = index === selectedIndex;
        return (
          <Stack
            key={category.name}
            cursor="pointer"
            onClick={() => onCategorySelect(index)}
            minWidth="max-content"
            justifyContent="center"
            whiteSpace="nowrap"
            alignItems="center"
            backgroundColor={{
              default: isSelected ? 'black' : 'inherit',
              hover: isSelected ? 'black' : 'grey_200',
            }}
            borderRadius="2xl"
            paddingX="4"
            paddingY="3"
            className={menuItemClass}
          >
            <Typography
              color={{ default: isSelected ? 'grey_100' : 'grey_800' }}
              fontWeight="semibold"
              size={{
                default: 'b_sm',
                md: 'b_md',
              }}
              textAlign="center"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
              className={menuItemTextClass}
            >
              {translate(category.labelTranslationKey)}
            </Typography>
          </Stack>
        );
      })}
    </DragScrollCarousel>
  </Container>
);

export default GigCategoriesMenu;
